import {
  require_highcharts
} from "./chunk-22FI7YQ2.js";
import {
  __toESM
} from "./chunk-AC2VUBZ6.js";

// ../../shared/node_modules/vue-highcharts/src/index.js
var import_highcharts = __toESM(require_highcharts());

// ../../shared/node_modules/vue-highcharts/src/constrators.js
var constrators_default = {
  highcharts: "Chart",
  highstock: "StockChart",
  highmaps: "Map",
  "highcharts-renderer": "Renderer"
};

// ../../shared/node_modules/vue-highcharts/src/clone.js
function clone(obj) {
  var copy;
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (obj instanceof Array) {
    copy = [];
    for (var i = obj.length - 1; i >= 0; i--) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }
  if (obj instanceof Object) {
    copy = {};
    for (var key in obj) {
      copy[key] = clone(obj[key]);
    }
    return copy;
  }
}

// ../../shared/node_modules/vue-highcharts/src/create.js
function create(tagName, Highcharts, Vue) {
  var Ctor = Highcharts[constrators_default[tagName]];
  if (!Ctor) {
    return null;
  }
  var isRenderer = tagName === "highcharts-renderer";
  var component = {
    name: tagName,
    props: isRenderer ? {
      width: { type: Number, required: true },
      height: { type: Number, required: true }
    } : { options: { type: Object, required: true } },
    methods: {
      _initChart: function() {
        this._renderChart();
        if (isRenderer) {
          this.$watch("width", this._renderChart);
          this.$watch("height", this._renderChart);
        } else {
          this.$watch("options", this._renderChart, { deep: true });
        }
      },
      _renderChart: function() {
        if (isRenderer) {
          this.renderer && this.$el.removeChild(this.renderer.box);
          this.renderer = new Ctor(this.$el, this.width, this.height);
        } else {
          this.chart = new Ctor(this.$el, clone(this.options));
        }
      }
    },
    beforeDestroy: function() {
      if (isRenderer) {
        this.$el.removeChild(this.renderer.box);
        for (var property in this.renderer) {
          delete this.renderer[property];
        }
        this.renderer = null;
      } else {
        this.chart.destroy();
      }
    }
  };
  var isVue1 = /^1\./.test(Vue.version);
  if (isVue1) {
    component.template = "<div></div>";
    component.ready = function() {
      this._initChart();
    };
  } else {
    component.render = function(createElement) {
      return createElement("div");
    };
    component.mounted = function() {
      this._initChart();
    };
  }
  return component;
}
var create_default = create;

// ../../shared/node_modules/vue-highcharts/src/index.js
function install(Vue, options) {
  var Highcharts = options && options.Highcharts || import_highcharts.default;
  Vue.prototype.Highcharts = Highcharts;
  for (var tagName in constrators_default) {
    var component = create_default(tagName, Highcharts, Vue);
    component && Vue.component(tagName, component);
  }
}
var src_default = install;

export {
  src_default
};
//# sourceMappingURL=chunk-IUBTGYMV.js.map
